import { render, staticRenderFns } from "./ModalSetSpacePrice.vue?vue&type=template&id=90f0b1e4"
import script from "./ModalSetSpacePrice.vue?vue&type=script&lang=js"
export * from "./ModalSetSpacePrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports